import script from "./LuceneExpressionFixButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LuceneExpressionFixButton.vue?vue&type=script&setup=true&lang=js"

import "./LuceneExpressionFixButton.vue?vue&type=style&index=0&id=5cadd3eb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cadd3eb"]])

export default __exports__